export function stableStepDataEquals(left: unknown, right: unknown): boolean {
    return JSON.stringify(normalizeForStableCompare(left)) === JSON.stringify(normalizeForStableCompare(right));
}

function normalizeForStableCompare(value: unknown): unknown {
    if (value === null || typeof value !== "object") {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(normalizeForStableCompare);
    }
    const record = value as Record<string, unknown>;
    const sortedKeys = Object.keys(record).sort();
    const normalizedRecord: Record<string, unknown> = {};
    for (const propertyKey of sortedKeys) {
        const propertyValue = record[propertyKey];
        if (propertyValue === undefined) continue;
        normalizedRecord[propertyKey] = normalizeForStableCompare(propertyValue);
    }
    return normalizedRecord;
}
